import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useMultipleDealerIds } from '../../../components/contexts/DealerContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import EventList from '../../shared/EventList';

const EventListPage = () => {
    const { t } = useTranslation('eventList');
    const navigate = useNavigate();
    const { permissions: accountPermissions } = useAccount();
    const { dealerIds } = useMultipleDealerIds();

    const extra = hasPermissions(accountPermissions, [permissionKind.createEvent]) ? (
        <Button icon={<PlusOutlined />} onClick={() => navigate('/admin/events/add')} type="primary">
            {t('eventList:actions.create')}
        </Button>
    ) : null;

    return (
        <ConsolePageWithHeader extra={extra} title={t('eventList:title')}>
            <EventList dealerIds={dealerIds} pageType="Admin" />
        </ConsolePageWithHeader>
    );
};

export default EventListPage;
